import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    transactionByCar(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/statistics/web/getStudentsTransactionByCar?&date=" + obj,
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    transactionByStatus(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/statistics/web/getStudentsTransactionByStatus?&date=" + obj,
          method: 'GET',
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      });
    },
    countStudentsByLevel({
      rootGetters
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/statistics/web/getCountStudentsByLevel?id="+rootGetters.getBranch.id+"&date="+obj,
          method: 'GET',
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      });
    },

    countStudentsByGG({
      rootGetters
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/statistics/web/getCountStudentsByGG?id="+rootGetters.getBranch.id+"&date="+obj,
          method: 'GET',
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      });
    },

  timeStats({
    rootGetters
  }) {
    return new Promise((resolve, reject) => {
       axios({
         url: process.env.VUE_APP_URL + "statistics/web/getTimeStats?id="+rootGetters.getBranch.id,
         method: 'GET',
           }).then(response => {
             if (response.data.status) {
               resolve(response)
             } else {
               reject(response)
             }
           }).catch(error => {
             reject(error)
           })
     });
 },

 transactionByDoor({
  rootGetters
}, obj) {
  return new Promise((resolve, reject) => {
     axios({
       url: process.env.VUE_APP_URL + "/statistics/web/getStudentsTransactionByDoor?&date="+obj,
       method: 'GET',
         }).then(response => {
           if (response.data.status) {
             resolve(response)
           } else {
             reject(response)
           }
         }).catch(error => {
           reject(error)
         })
   });
},

  }
}